"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractCluster = /** @class */ (function () {
    function AbstractCluster(id) {
        this.id = id;
    }
    AbstractCluster.prototype.clusterElementIds = function () {
        return this.leafClusters().map(function (e) { return e.id; });
    };
    AbstractCluster.prototype.clusterElements = function () {
        return this.leafClusters().map(function (e) { return e.object; });
    };
    AbstractCluster.prototype.size = function () {
        return this.leafClusters().length;
    };
    return AbstractCluster;
}());
exports.AbstractCluster = AbstractCluster;
